import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { makeStyles } from 'tss-react/mui';
import {EzFormControl} from 'wobi-web-common';

const useStyles = makeStyles()(() => ({
  smallSelect: {
    padding: 10,
  },
}));

const SmallSelect = (props) => {
  const { classes } = useStyles();
  const {name, label, width, ...rest} = props;
  return (
    <EzFormControl
      formControlProps={{size: 'small'}}
      name={name}
      label={label}
      isLabelInChild
    >
      <TextField
        select
        color='primary'
        size='small'
        style={{width}}
        SelectProps={{classes: {select: classes.smallSelect},}}
        {...rest}
      />
    </EzFormControl>
  );
};

SmallSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.string,
};

SmallSelect.defaultProps = {
  width: '100%',
};

export default SmallSelect;
